module.exports = "<section class=\"hero\">\n  <h1>This is the NG6 starter</h1>\n  <h3>You can find me inside {{ $ctrl.name }}.html</h3>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/hero/hero.html
// module id = 457
// module chunks = 0